import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { useDestroyDashboardUser, useUpdateDashboardUser } from 'api/hooks/use-dashboard-user'
import { useQueryClient } from 'react-query'
import MutedText from 'shared/forms/muted-text'

function UserRow({ dashboardUser, editable, dashboardId }) {
  const queryClient = useQueryClient()
  const [isEditor, setIsEditor] = useState(dashboardUser.is_editor || false)

  const options = {
    onSuccess: () => {
      queryClient.invalidateQueries([`dashboards/${dashboardId}`])
      queryClient.invalidateQueries('dashboards')
    }
  }

  const { mutate: destroyMutation, isLoading: isDestroying } = useDestroyDashboardUser({
    id: dashboardUser.id,
    options
  })

  const { mutate: updateMutation, isLoading: isUpdating } = useUpdateDashboardUser({
    id: dashboardUser.id,
    options: {
      ...options,
      onSuccess: (data) => {
        // Only update local state after successful API response
        if (data && data.is_editor !== undefined) {
          setIsEditor(data.is_editor)
        }
        options.onSuccess()
      }
    }
  })

  const handleRoleChange = (e) => {
    // Pass the new value directly to the mutation
    updateMutation({ is_editor: e.target.value === 'editor' })
  }

  return (
    <tr>
      <td>
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div>
            {dashboardUser.first_name} {dashboardUser.last_name}
            <MutedText as="div">
              <small>{dashboardUser.email}</small>
            </MutedText>
          </div>
          {editable && (
            <Form.Select
              size="sm"
              id={`editor-select-${dashboardUser.id}`}
              aria-label="Access role"
              value={isEditor ? 'editor' : 'viewer'}
              onChange={handleRoleChange}
              disabled={isUpdating || isDestroying}
              style={{ width: 'auto' }}
            >
              <option value="viewer">Viewer</option>
              <option value="editor">Editor</option>
            </Form.Select>
          )}
        </div>
      </td>
      <td className="text-end border-bottom-0">
        {editable && (
          <Button
            variant="light"
            className="bg-light"
            onClick={() => destroyMutation()}
            disabled={isDestroying || isUpdating}
          >
            <FontAwesomeIcon icon={faTrash} className="text-danger" />
          </Button>
        )}
      </td>
    </tr>
  )
}

export default UserRow

